import { render } from "./InternationalInvestmentPosition.vue?vue&type=template&id=561038a4"
import script from "./InternationalInvestmentPosition.vue?vue&type=script&lang=js"
export * from "./InternationalInvestmentPosition.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__